import { FormCard, FormItem, Select, TextArea } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { CARER_GENDER_GENDER } from 'common/constants'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const CarerPreferenceFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  const carerGenderOptions = CARER_GENDER_GENDER.map((gender) => ({
    value: gender.value,
    label: <Text>{t(supConstants[gender.value])}</Text>
  }))

  return (
    <FormCard title={t(supConstants.CARER_PREFERENCE)}>
      <FormItem
        label={<Text>{t(supConstants.CARER_GENDER)}</Text>}
        name={['carerPreferences', 'carerGender']}
      >
        <Select options={carerGenderOptions} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.CARER_PREFERENCE_NOTE)}</Text>}
        name={['carerPreferences', 'carerNotes']}
      >
        <TextArea
          autoSize={{
            minRows: 3
          }}
        />
      </FormItem>
    </FormCard>
  )
}
